import { request } from "@/lib/api";
import { userInfoSelector } from "@/recoil/userInfo";
import React, { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import { deviceTypeState } from "@/recoil/deviceType";
import { LoadingSpinner } from "@/components/atoms/LoadingSpinner";
import {
  readAccessToken,
  readProfileId,
  readRefreshToken,
} from "@/lib/authFunctions";
import { profileIdState } from "@/recoil/profileId";

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useRecoilState(userInfoSelector);
  const setDeviceType = useSetRecoilState(deviceTypeState);
  const setProfileId = useSetRecoilState(profileIdState);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  // 인증이 필요없는 페이지 목록을 상수로 분리
  const PUBLIC_PATHS = [
    "/intro",
    "/auth/login",
    "/auth/join/form",
    "/auth/find/user-account",
    // "/auth/join/form01",
    "/auth/join/form02",
    "/auth/join/form03",
    "/auth/join/select",
    "/mypage/setting/terms",
    "/mypage/setting/privacy",
    "/mypage/setting/cancel-membership",
    "/auth/join/buy",
    "/auth/profile/select",
    "/auth/profile/form",
    "/admin/stroke-order-generator",
  ];

  // 디바이스 타입 체크 로직
  useEffect(() => {
    const checkDeviceType = () => {
      setDeviceType(window.innerWidth >= 800 ? "pad" : "phone");
    };

    checkDeviceType();
    window.addEventListener("resize", checkDeviceType);
    return () => window.removeEventListener("resize", checkDeviceType);
  }, []);

  // 인증 체크 로직
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const [accessToken, refreshToken, profileId] = await Promise.all([
          readAccessToken(),
          readRefreshToken(),
          readProfileId(),
        ]);

        if (profileId) setProfileId(profileId);

        if (!accessToken && !refreshToken) {
          if (!PUBLIC_PATHS.includes(location.pathname)) {
            navigate("/auth/login");
          }
          setIsLoading(false);
          return;
        }

        const response: any = await request({
          method: "GET",
          url: "/auth/info",
        });

        setUser(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("인증 체크 실패:", error);
        if (!PUBLIC_PATHS.includes(location.pathname)) {
          navigate("/auth/login");
        }
        setIsLoading(false);
      }
    };

    if (!PUBLIC_PATHS.includes(location.pathname)) {
      checkAuth();
    } else {
      setIsLoading(false);
    }
  }, [navigate, location.pathname]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return <>{children}</>;
};
